"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ar = exports.decodeArAddress = exports.encodeArAddress = void 0;
const base_1 = require("@scure/base");
const name = "ar";
const coinType = 472;
exports.encodeArAddress = base_1.base64urlnopad.encode;
exports.decodeArAddress = base_1.base64urlnopad.decode;
exports.ar = {
    name,
    coinType,
    encode: exports.encodeArAddress,
    decode: exports.decodeArAddress,
};
//# sourceMappingURL=ar.js.map